import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { exchangeMagicToken } from './api/applicant';
import { takeMagicToken } from './apply/magicLink';
import { ErrorFallback } from './lib/ErrorFallback';
import { initSentry } from './lib/sentry';
import './index.css';

// Strip the bearer credential before React, routers, or future analytics code
// — including Sentry — can observe it. Creating one promise here also prevents
// React StrictMode's development-only effect replay from submitting the
// one-time token twice.
const magicToken = takeMagicToken(window.location, window.history);

// Initialize only after the magic-link credential has left the URL, but before
// the exchange or first render so failures in either path are still captured.
// This is a no-op when VITE_SENTRY_DSN is unset (see src/lib/sentry.ts).
initSentry();

const magicSession = magicToken ? exchangeMagicToken(magicToken) : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App magicSession={magicSession} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
